<template>
  <div v-if="product">
    <Product
      :product="product"
      :package-items="packageItems"
      :package-upgrades="packageUpgrades"
      :package-editions="packageEditions"
    />
  </div>
</template>

<script>
import { productMethods, productComputed } from '@/store/helper';
import Product from '@/components/Products/Single.vue';

const include = 'package-items.product,package-items.upgrades,package-editions.package-items';

export default {
  name: 'AccountProductShow',
  components: {
    Product,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...productComputed,
  },
  created() {
    const { productId } = this;

    this.fetchProduct({ productId, params: { include } });
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...productMethods,
  },
};
</script>
